import { Injectable, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';

@Injectable()
export class BusyService {
  isBusy: {} = {};
  private handlers: any = {};
  private observables = {};


  constructor() {}

  initHandler(key, handler: Function) {
    this.handlers[key] = handler;
  }

  busy(key) {
    this.isBusy[key] = true;
    this.handlers[key](true);
  }

  alive(key: string) {
    this.isBusy[key] = false;
    this.handlers[key](false);
  }

  toggle(key: string) {
    this.isBusy[key] = !this.isBusy[key];
    this.handlers[key](this.isBusy[key]);
  }

  follow(key, obs: Observable<any>): Observable<any> {
    this.busy(key);
    obs.share();

    if(!this.observables[key]){
      this.observables[key] = [];
    }
    const index = this.observables[key].push(false) - 1;

    const subscription = () => {
      const i = index;
      this.observables[key][i] = true;
      this.tryAlive(key);
    };

    obs.subscribe(subscription, subscription);

    return obs;
  }

  private tryAlive(key) {
    if (this.checkObservables(key)) {
      this.alive(key);
      this.resetObservablesAggregator(key);
    }
  }

  private checkObservables(key): boolean {
    const countOfIncompleObs = this.observables[key].filter(o => {
      return !o;
    }).length;
    if (countOfIncompleObs > 0) {
      return false;
    } else {
      return true;
    }
  }

  private resetObservablesAggregator(key) {
    this.observables[key] = [];
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/busy.service.ts